import React, { Component } from 'react';

import FormSettings from '../../../shared/constants/form-settings';

import SVGIcon from '../../../../../../common/react/components/svg-icon';

import classNames from 'classnames';

export default class NotificationsSection extends Component {
	constructor(props) {
		super(props);

		this.validEmailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		
		this.state = {
			emails: props.notificationEmailAddresses
		};
	}

	render() {
		let { localization } = this.props;
		let { emails } = this.state;
		let placeholder = emails.length > 0 ? '' : localization.substitute('Enter email addresses separated by commas');
		
		return (
			<section className='notifications'>
				<h2>{localization.substitute('Notification Emails')}</h2>

				<label htmlFor='notification_emails'>{localization.substitute('Notify these individuals in the organization when new submissions occur')}</label>
				<section className='emails'>
					<div className={classNames({'empty': emails.length === 0}, 'tags')} onClick={this.focusInput}>
						{ this.getTagList() }
						<input
							ref='notificationEmailInput'
							id='notification_emails'
							type='text'
							placeholder={localization.substitute(placeholder)}
							onKeyDown={this.handleKeyDown}
							onBlur={this.handleBlur}
						></input>
					</div>
				</section>

				<section>
					<input
						id='include_response_in_admin_digest_toggle_checkbox'
						type='checkbox'
						value={this.props.includeResponse}
						defaultChecked={this.props.includeResponse}
						onClick={this.handleToggle(FormSettings.INCLUDE_RESPONSE_IN_ADMIN_DIGEST)}
					></input>
					<label htmlFor='include_response_in_admin_digest_toggle_checkbox'>
						{localization.substitute('Include form response')}
					</label>
				</section>
			</section>
		);
	}

	// Custom Methods ------------------------------------------------------------

	addEmails = () => {
		let { notificationEmailInput } = this.refs;
		let { emails } = this.state;
		let newEmails = notificationEmailInput.value.split(',');

		newEmails.forEach(email => {
			if (this.validEmailRegex.test(email)) {
				emails.push(email.trim());
			}
		});

		this.setState({
			emails: emails
		});

		this.props.updateCallback(FormSettings.NOTIFICATION_EMAIL_LIST, this.state.emails);
	}

	focusInput = () => {
		this.refs.notificationEmailInput.focus();
	}

	getTagList = () => {
		return this.state.emails.map((email, index) => {
			return (
				<div className='tag' key={`${email}_${index}`}>
					<span className='label'>{email}</span>
					<a href='#' onClick={this.removeEmail(email)}>
						<SVGIcon name='times' />
					</a>
				</div>
			);
		})
	}

	handleBlur = () => {
		let input = this.refs.notificationEmailInput.value;

		if ( input !== '' ) {
			this.addEmails();
			this.refs.notificationEmailInput.value = '';
		}
	}

	handleKeyDown = evt => {
		// Listen for 'Enter' or 'Escape' keypress
		if ( evt.keyCode === 13 ) {
			this.addEmails();
			this.refs.notificationEmailInput.value = '';
		} else if ( evt.keyCode === 27 ) {
			this.refs.notificationEmailInput.value = '';
		}
	}
	
	handleToggle = (propertyName) => {
		return (evt) => {
			this.props.updateCallback(propertyName, evt.target.checked)
		}
	}

	removeEmail = email => {
		return (evt) => {
			evt.preventDefault();

			let { emails } = this.state;
			emails.splice(emails.indexOf(email), 1);

			this.setState({
				emails: emails
			});

			this.props.updateCallback(FormSettings.NOTIFICATION_EMAIL_LIST, this.state.emails);
		}
	}
}



// WEBPACK FOOTER //
// ./src/main/webapps/features/form-builder/react/advanced-settings/components/sections/notifications.js